import { com } from '@eidu/web'
import entityApiUrl from '../baseUrl'
import requireValidPaginationParameters from '../common/requireValidPaginationParameters'
import fetchAuthorized from '../../authorization/fetchAuthorized'
import requireAuthContext from '../../authorization/requireAuthContext'
import EntityType = com.eidu.entity.type.EntityType
import entityTypePaginatedResponseFromJsonString = com.eidu.entity.api.types.entityTypePaginatedResponseFromJsonString
import IndexedPaginatedResponse = com.eidu.api.pagination.IndexedPaginatedResponse

type GetEntityTypesParameters = { pageIndex: number; pageSize: number }

const getEntityTypes = async ({
  pageIndex,
  pageSize,
}: GetEntityTypesParameters): Promise<IndexedPaginatedResponse<EntityType> | null> => {
  requireValidPaginationParameters(pageIndex, pageSize)
  const authContext = await requireAuthContext()
  const url = `${entityApiUrl}/organizations/${authContext.organizationId}/types?pageIndex=${pageIndex}&pageSize=${pageSize}`

  return fetchAuthorized(url, {
    headers: {
      Accept: 'application/json',
    },
  }).then(async (response) => {
    console.debug('[getEntityTypes] response', { status: response.status })
    switch (response.status) {
      case 200:
        return entityTypePaginatedResponseFromJsonString(await response.text()) as IndexedPaginatedResponse<EntityType>
      case 404:
        console.warn(`Got status ${response.status} from getEntityTypes endpoint`)
        return null
      default:
        throw Error(`Unexpected response code ${response.status} from getEntityTypes endpoint`)
    }
  })
}

export default getEntityTypes
